import { Button, Input, Label, Loader, SelectGeneric, Switch } from 'ypf-pas-general-ui-components';
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai';
import { Col, Row, OverlayTrigger, Tooltip, Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { formatDayName } from '../../../../utils/formatUtils';
import { workReportLineStatus } from '../../../../utils/dataStatus';
import useProgramPoint from '../useProgramPoint';
import { setInputBackgroundColor } from '../../../../utils/workReportLinesUtils';
import { certificationServiceStatus } from '../../../../constants/constants';
import { checkRol } from '../../../../security';
import { inspector } from '../../../../security/constantsRols';

const ProgramPointList = ({
  line,
  selectedDate,
  loading,
  values,
  setFieldValue,
  disabledInputQuantity,
  disabledInputPP,
  disabledButton,
  quantityTotalReturn,
  displayButtons,
  displayFixedlabel,
  dailyView,
  onChangeExpertReview,
  showRectifyQuantityButton,
  handleClickRectifyButton,
  showTitle,
  viewCSA,
  editCSA,
  showAlert,
  tipoAsignacion,
  idParteDiario,
  showExpertReview,
  viewInputs
}) => {
  const {
    handleSuprPP,
    handleAddPP,
    handleChangePoints,
    handleChangeQuantity,
    handleChangeCode,
    handleChangeSubCode,
    handleChangeCost,
    costOptions
  } = useProgramPoint({
    values,
    setFieldValue,
    notificaPorCSA: line?.notificaPorCSA,
    tipoAsignacion,
    idParteDiario
  });

  const isInspector = checkRol(inspector);
  const isFixedOrReturnedAndHasPP =
    line?.estadoEnum === workReportLineStatus.fijar ||
    line?.estadoEnum === workReportLineStatus.devolver
      ? line?.tienePuntosPrograma
      : false;

  return (
    <>
      {showTitle && (
        <div className="text-center modal-info mb-4">
          <div className="d-flex justify-content-center flex-wrap">
            <span>
              &quot;{line?.positionName} {line?.lineName}
              <br />
              Para el día {formatDayName(selectedDate)},{'  '}
              {new Date(new Date(selectedDate).getTime() + 24 * 60 * 60 * 1000).toLocaleDateString(
                'es',
                {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                }
              )}
            </span>
          </div>
        </div>
      )}
      <hr className="divide-line mt-4 " />
      {showAlert && (
        <Alert bsPrefix="fade alert alert-color" variant="warning">
          <span className="alert-color-text">
            Falta completar datos operativos, código y subcódigo.
          </span>
        </Alert>
      )}

      {loading && <Loader show={loading} text="Cargando" />}
      <div style={{ display: 'flex', flexDirection: 'column', height: '200px' }}>
        <div style={{ marginBottom: '10px' }}>
          <Row>
            <Col sm={2} style={{ marginLeft: '5px' }}>
              <Label
                label={`Cantidad ${' '} [${line.unidadMedida}]`}
                size="md"
                sizeValue="md"
                style={{ display: 'flex' }}
              />
            </Col>
            <Col sm={1} style={{ marginRight: '15px' }}>
              <Label label="P. Prog." size="md" sizeValue="md" />
            </Col>
            {line?.estadoEnum === workReportLineStatus.fijar && dailyView && (
              <>
                <Col sm={2} style={{ marginLeft: displayButtons ? '0px' : '0px' }}>
                  <Label label="Fijado" size="md" sizeValue="sm" />
                </Col>
                <Col sm={1} style={{ padding: '0px' }}>
                  <Label label="P.P. Fijado" size="md" sizeValue="sm" />
                </Col>
              </>
            )}
            {viewCSA && (
              <>
                <Col
                  sm={2}
                  style={{
                    // eslint-disable-next-line no-nested-ternary
                    marginLeft: displayButtons
                      ? '70px'
                      : line?.estadoEnum === workReportLineStatus.fijar && dailyView
                      ? '0px'
                      : '25px'
                  }}
                >
                  <Label label="Clas. C /F. Op." size="md" sizeValue="md" />
                </Col>
                <Col
                  sm={1}
                  // style={{ marginLeft: '20px' }}
                >
                  <Label label="Cod. C." size="md" sizeValue="sm" />
                </Col>
                {line?.estadoEnum === workReportLineStatus.fijar && dailyView ? (
                  <>
                    <Col sm={1} style={{ marginLeft: '15px' }}>
                      <Label label="Subcodigo" size="md" sizeValue="sm" />
                    </Col>
                    <Col style={{ marginLeft: '25px' }}>
                      <Label label="Descripción" size="md" sizeValue="sm" />
                    </Col>
                  </>
                ) : (
                  <>
                    <Col sm={1} style={{ marginLeft: '15px' }}>
                      <Label label="Subcodigo" size="md" sizeValue="sm" />
                    </Col>
                    <Col style={{ marginLeft: '25px' }}>
                      <Label label="Descripción" size="md" sizeValue="sm" />
                    </Col>
                  </>
                )}
              </>
            )}
          </Row>
        </div>
        <div className="infinte-scroll">
          {values?.programPoints?.map((programPoint, index) => (
            <div className="input-row" key={`programPoint-${index.toString()}`}>
              <Row className="input-container g-3">
                <Col sm={2} style={{ display: 'flex' }}>
                  <Input
                    backgroundColor={
                      disabledInputQuantity && isInspector
                        ? setInputBackgroundColor({
                            dailyWorkReport: line
                          })
                        : ''
                    }
                    className="w-100 style-input-modal"
                    disabled={disabledInputQuantity}
                    name="quantity"
                    onChange={(val) => handleChangeQuantity(val, index)}
                    placeholder="--"
                    type="number"
                    value={programPoint?.quantity}
                  />
                </Col>
                <Col className="compact-input" sm={1} style={{ padding: '0.5px' }}>
                  <Input
                    className=" style-input-modal gap-2"
                    disabled={disabledInputPP}
                    name="points"
                    onChange={(val) => handleChangePoints(val, index)}
                    placeholder="--"
                    type="number"
                    value={programPoint?.points}
                  />
                </Col>
                {line?.estadoEnum === workReportLineStatus.fijar && dailyView && (
                  <>
                    <Col
                      sm={2}
                      style={{
                        marginLeft: displayButtons ? '0px' : '20px'
                      }}
                    >
                      <Input
                        className="style-input-modal"
                        disabled={disabledInputPP}
                        name="points"
                        onChange={(val) => handleChangePoints(val, index)}
                        placeholder="--"
                        type="number"
                        value={programPoint?.quantityFijados}
                      />
                    </Col>
                    <Col sm={1}>
                      <Input
                        className="style-input-modal"
                        disabled={disabledInputPP}
                        name="points"
                        onChange={(val) => handleChangePoints(val, index)}
                        placeholder="--"
                        value={programPoint?.pointsFijados}
                      />
                    </Col>
                  </>
                )}
                {displayButtons && (
                  <Col
                    sm={1}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }}
                  >
                    <div style={{ display: 'flex' }}>
                      <Button
                        colorIcon="danger"
                        disabled={values?.programPoints?.length === 1 || disabledButton}
                        icon={AiOutlineMinusCircle}
                        onClick={() => handleSuprPP(index)}
                        sizeIcon="24px"
                        type="button"
                        variant="light-gray"
                        widthButton="40px"
                      />
                      <Button
                        colorIcon="primary"
                        disabled={
                          values?.programPoints?.find(
                            (qntyObj) => !qntyObj.quantity || !qntyObj.points
                          ) || disabledButton
                        }
                        icon={AiOutlinePlusCircle}
                        onClick={() => handleAddPP()}
                        sizeIcon="24px"
                        type="button"
                        variant="light-gray"
                        widthButton="40px"
                      />
                    </div>
                  </Col>
                )}
                {viewCSA && (
                  <>
                    <Col
                      sm={2}
                      style={{
                        // eslint-disable-next-line no-nested-ternary
                        marginLeft: displayButtons
                          ? '0px'
                          : line?.estadoEnum === workReportLineStatus.fijar && dailyView
                          ? ''
                          : '50px',
                        marginBottom: viewInputs ? '0px' : '-18px'
                      }}
                    >
                      {viewInputs ? (
                        <Input
                          className="w-auto"
                          disabled
                          value={
                            values?.programPoints[index]?.cost?.label ||
                            values?.programPoints[index]?.cost
                          }
                        />
                      ) : (
                        <SelectGeneric
                          className="w-auto"
                          isDisabled={!editCSA}
                          menuPosition="fixed"
                          name="cost"
                          onChange={(e) => handleChangeCost(e, index)}
                          optionMapper={{
                            value: 'id',
                            label: 'nombre'
                          }}
                          options={costOptions}
                          paddingIndicator={4}
                          placeholder="-- "
                          value={values?.programPoints[index]?.cost}
                          withSelect="100%"
                        />
                      )}
                    </Col>
                    <Col
                      sm={1}
                      style={{
                        padding: '0.5px',
                        marginLeft: '15px',
                        // marginTop: '35px',
                        marginBottom: viewInputs ? '0px' : '-18px',
                        marginRight: '15px'
                      }}
                    >
                      {viewInputs ? (
                        <Input
                          className="w-auto"
                          disabled
                          value={
                            values?.programPoints[index]?.code?.label ||
                            values?.programPoints[index]?.code
                          }
                        />
                      ) : (
                        <SelectGeneric
                          isDisabled={!editCSA}
                          menuPosition="fixed"
                          name="code"
                          onChange={(e) => handleChangeCode(e, index)}
                          optionMapper={{
                            value: 'id',
                            label: 'nombre'
                          }}
                          options={values?.programPoints[index].optionsCode}
                          paddingIndicator={4}
                          placeholder="-- "
                          value={values?.programPoints[index]?.code}
                          withSelect="100%"
                        />
                      )}
                    </Col>
                    <Col
                      sm={1}
                      style={{
                        padding: '0.5px',
                        marginLeft: '0px',
                        marginBottom: viewInputs ? '0px' : '-18px'
                      }}
                    >
                      {viewInputs ? (
                        <Input
                          className="w-auto"
                          disabled
                          value={
                            values?.programPoints[index]?.subCode?.label ||
                            values?.programPoints[index]?.subCode
                          }
                        />
                      ) : (
                        <SelectGeneric
                          isDisabled={!editCSA}
                          menuPosition="fixed"
                          name="subCode"
                          onChange={(e) => handleChangeSubCode(e, index)}
                          optionMapper={{
                            value: 'id',
                            label: 'nombre'
                          }}
                          options={values?.programPoints[index].optionsSubCode}
                          paddingIndicator={4}
                          placeholder="-- "
                          value={values?.programPoints[index]?.subCode}
                          withSelect="100%"
                        />
                      )}
                    </Col>
                    <Col
                      style={{
                        padding: '0.5px',
                        marginLeft: '40px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: '500px'
                      }}
                    >
                      <OverlayTrigger
                        className=""
                        delay={{
                          show: 250,
                          hide: 400
                        }}
                        overlay={
                          <Tooltip id="button-tooltip">
                            <span>{values?.programPoints[index]?.detail || '--'}</span>
                          </Tooltip>
                        }
                        placement="top"
                      >
                        <span>{values?.programPoints[index]?.detail || '--'}</span>
                      </OverlayTrigger>
                    </Col>
                  </>
                )}
                {showRectifyQuantityButton && index === 0 && (
                  <Col
                    className="px-3 py-2"
                    sm={3}
                    style={{ display: 'flex', justifyContent: 'flex-end' }}
                  >
                    <Button
                      fontSizeLabel="14px"
                      label={disabledInputQuantity ? 'Rectificar cantidad' : 'Cancelar'}
                      onClick={handleClickRectifyButton}
                      sizeIcon="17px"
                      type="button"
                      variant="outline-primary"
                    />
                  </Col>
                )}

                {line?.estadoRevision?.estadoCertEnum !== certificationServiceStatus.wrong &&
                  isInspector &&
                  showExpertReview &&
                  showRectifyQuantityButton &&
                  index === 0 && (
                    <Col
                      className="d-flex justify-content-between align-items-start col-sm-3 py-2"
                      sm={3}
                    >
                      <div className="d-flex align-items-center">
                        <h6 className="mx-2 my-0">Revisión experta</h6>
                        <Switch
                          checked={values?.expertReview}
                          falseLabel="NO"
                          name="expertReview"
                          onChange={onChangeExpertReview}
                          size="sm"
                          trueLabel="SÍ"
                        />
                      </div>
                    </Col>
                  )}
              </Row>
            </div>
          ))}
        </div>
      </div>

      <hr className="divide-line" />
      <div className="label-total-container">
        <span
          style={{
            paddingRight: '10px',
            fontWeight: 'bold',
            fontSize: '18px',
            alignItems: 'center'
          }}
        >
          {values?.totalValue || '--'} {'  '}
          {line?.unidadMedida}
        </span>
        <span
          style={{
            paddingRight: '10px',
            alignItems: 'center',
            display: 'flex'
          }}
        >
          cantidad total notificada{' '}
        </span>
        {isFixedOrReturnedAndHasPP && displayFixedlabel && ` | `}
        <span
          style={{
            paddingLeft: '10px',
            fontSize: '18px',
            color: line?.estadoEnum === workReportLineStatus.devolver ? '#ff0000c2' : '#44adde'
          }}
        >
          {isFixedOrReturnedAndHasPP &&
            displayFixedlabel &&
            ` ${quantityTotalReturn} ${line?.unidadMedida} cantidad ${
              line?.estadoEnum === workReportLineStatus.devolver ? 'devuelta' : 'fijada'
            } `}
        </span>
      </div>
      <hr className="divide-line mt-4 mb-0" />
    </>
  );
};

export default ProgramPointList;

ProgramPointList.propTypes = {
  line: PropTypes.shape({
    positionName: PropTypes.string,
    lineName: PropTypes.string,
    idParteDiario: PropTypes.number,
    estadoEnum: PropTypes.number,
    tienePuntosPrograma: PropTypes.bool,
    unidadMedida: PropTypes.string,
    estadoRevision: PropTypes.shape({
      estadoCertEnum: PropTypes.number
    }),
    notificaPorCSA: PropTypes.bool
  }),
  values: PropTypes.shape({
    programPoints: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        quantity: PropTypes.number,
        points: PropTypes.number,
        fecha: PropTypes.string,
        code: PropTypes.shape({}),
        optionsSubCode: PropTypes.PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            nombre: PropTypes.string
          })
        ),
        subCode: PropTypes.PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            nombre: PropTypes.string
          })
        ),
        optionsActivities: PropTypes.arrayOf(PropTypes.shape({})),
        activity: PropTypes.shape({}),
        detail: PropTypes.string
      })
    ),
    totalValue: PropTypes.number,
    expertReview: PropTypes.bool
  }),
  disabledButton: PropTypes.bool,
  selectedDate: PropTypes.string,
  loading: PropTypes.bool,
  disabledInputQuantity: PropTypes.bool,
  disabledInputPP: PropTypes.bool,
  quantityTotalReturn: PropTypes.string,
  dailyView: PropTypes.bool,
  displayFixedlabel: PropTypes.bool,
  setFieldValue: PropTypes.func,
  displayButtons: PropTypes.bool,
  showRectifyQuantityButton: PropTypes.bool,
  handleClickRectifyButton: PropTypes.func,
  onChangeExpertReview: PropTypes.func,
  showTitle: PropTypes.bool,
  viewCSA: PropTypes.bool,
  editCSA: PropTypes.bool,
  showAlert: PropTypes.bool,
  tipoAsignacion: PropTypes.number.isRequired,
  idParteDiario: PropTypes.number.isRequired,
  showExpertReview: PropTypes.bool,
  viewInputs: PropTypes.bool
};
ProgramPointList.defaultProps = {
  line: {
    positionName: '',
    lineName: '',
    idParteDiario: 0,
    estadoEnum: 0,
    tienePuntosPrograma: false
  },
  values: {
    programPoints: [],
    totalValue: 0
  },
  disabledButton: false,
  disabledInputQuantity: false,
  disabledInputPP: false,
  selectedDate: new Date().toISOString().split('T')[0],
  loading: false,
  quantityTotalReturn: 0,
  dailyView: false,
  displayFixedlabel: false,
  setFieldValue: () => {},
  onChangeExpertReview: () => {},
  displayButtons: false,
  showRectifyQuantityButton: false,
  handleClickRectifyButton: () => {},
  showTitle: false,
  viewCSA: false,
  editCSA: false,
  showAlert: false,
  showExpertReview: false,
  viewInputs: false
};
